import { render, staticRenderFns } from "./reserve-nbn-appointment.vue?vue&type=template&id=5b376f27&scoped=true"
import script from "./reserve-nbn-appointment.vue?vue&type=script&lang=js"
export * from "./reserve-nbn-appointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b376f27",
  null
  
)

export default component.exports